import { Map, MapCameraChangedEvent, InfoWindow } from "@vis.gl/react-google-maps";
import { Typography } from "@mui/material";
import { Polygon as MapPolygon } from "../../JobsDashboard/map";
import { MarkerWithInfoWindow } from "../../JobsDashboard/map/MarkerWithInfoWindow";
import { JobMapProps } from "./JobMap.types";
import { useJobMapViewModel } from "./JobMap.vm";
import "./JobMap.css";

export default function JobMap(props: JobMapProps) {
	const vm = useJobMapViewModel(props);

	// Early return if maps library not loaded
	if (!vm.mapsLibraryLoaded) {
		return <div>Loading...</div>;
	}

	return (
		<Map
			className={`portal-map${props.lassoMode ? " lasso-mode" : ""}`}
			style={props.height ? { height: props.height } : undefined}
			mapId={"customerMaps"}
			zoom={vm.zoom}
			onBoundsChanged={(e: MapCameraChangedEvent) => {
				vm.onBoundsChanged(e.detail.bounds);
			}}
			onZoomChanged={(e: MapCameraChangedEvent) => {
				vm.onZoomChanged(e.detail.zoom);
			}}
			onClick={vm.onMapClick}
			defaultCenter={vm.center}
			defaultZoom={10}
		>
			{vm.visibleMapPolygons.map((poly) => (
				<MapPolygon
					key={poly.id}
					fillOpacity={poly.fillOpacity}
					fillColor={poly.fillColor}
					strokeWeight={2}
					strokeColor={poly.strokeColor}
					paths={poly.paths}
					clickable={!props.lassoMode}
					onClick={(e: google.maps.MapMouseEvent) => {
						if (e.latLng) {
							vm.onPolygonClick(poly.job, e.latLng.toJSON());
						}
					}}
				/>
			))}
			{vm.visibleMapMarkers.map((marker) => (
				<MarkerWithInfoWindow
					key={marker.id}
					iconColor={marker.iconColor}
					position={marker.position}
					clickable={!props.lassoMode}
					infoWindowText={
						<Typography variant="body2">
							Sample ID: {marker.sampleId}
							<br />
							Barcode: <b>{marker.barcode}</b>
							<br />
							Moved? {marker.hasChange ? `Yes (${marker.changeType})` : "No"}
							{marker.changeReason ? `: ${marker.changeReason}` : ""}
						</Typography>
					}
					label={marker.sampleId || ""}
				/>
			))}
			{vm.activePopup && (
				<InfoWindow position={vm.activePopup.position} onCloseClick={vm.onInfoWindowClose}>
					<Typography variant="body2">
						<strong>{vm.activePopup.job.importFieldName || vm.activePopup.job.fieldName || "Unnamed Field"}</strong>
						{(vm.activePopup.job.importFarmName || vm.activePopup.job.farmName) && (
							<>
								<br />
								Farm: {vm.activePopup.job.importFarmName || vm.activePopup.job.farmName}
							</>
						)}
						{(vm.activePopup.job.importGrowerName || vm.activePopup.job.growerName) && (
							<>
								<br />
								Grower: {vm.activePopup.job.importGrowerName || vm.activePopup.job.growerName}
							</>
						)}
					</Typography>
				</InfoWindow>
			)}
			{/* Lasso polyline is rendered natively in the view model for performance */}
		</Map>
	);
}
